<div class="flex">
  <a
    [routerLink]="Route.MultimediaGridView | routerLink"
    class="multimedia-view-switch"
    routerLinkActive="multimedia-view-switch--active">
    <p-button
      [text]="true"
      appPrimengButton
      pTooltip="Widok siatki"
      tabindex="-1">
      <app-icon [icon]="Icon.GridFill" />
    </p-button>
  </a>

  <a
    [routerLink]="Route.MultimediaListView | routerLink"
    class="multimedia-view-switch"
    routerLinkActive="multimedia-view-switch--active">
    <p-button
      [text]="true"
      appPrimengButton
      pTooltip="Widok listy"
      tabindex="-1">
      <app-icon [icon]="Icon.ListTask" />
    </p-button>
  </a>
</div>
